import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountStatusRedirectService } from '../services/account-status-redirect/account-status-redirect.service';
import { StorageService } from '../services/storage/storage.service';

/**
 * Sócio com plano e cadastro já aprovado não veem a landing.
 * Cadastro incompleto (ou JWT sem status — resposta da etapa 1) pode voltar para `/`.
 */
export const landingGuard: CanActivateFn = async () => {
  const storage = inject(StorageService);
  const router = inject(Router);
  const accountRedirect = inject(AccountStatusRedirectService);

  const jwt = await storage.get('jwt');
  if (!jwt) {
    return true;
  }

  if (await accountRedirect.usuarioPossuiAssinaturaAtiva()) {
    return router.parseUrl('/tabs/home');
  }

  const status = await accountRedirect.readStoredStatus();
  const cadastroFechado =
    status === 'Cadastro aprovado acesso normal' ||
    status === 'Cadastro aprovado primeiro acesso' ||
    status === 'Cadastro enviado' ||
    status === 'Não contratado';

  if (!cadastroFechado) {
    return true;
  }

  const urlTree = await accountRedirect.resolveSessionUrlTree('/');
  if (urlTree) {
    return urlTree;
  }

  const destino = await accountRedirect.resolveOnboardingDestino();
  if (destino && destino !== '/') {
    return router.parseUrl(destino);
  }

  return true;
};
